import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "serp__filter--range-container q-row" }
const _hoisted_2 = { class: "serp__filter--range-min q-col-6" }
const _hoisted_3 = { class: "q-small" }
const _hoisted_4 = ["data-field", "id", "name", "placeholder", "min"]
const _hoisted_5 = {
  key: 0,
  class: "q-input-group-text q-unit"
}
const _hoisted_6 = { class: "serp__filter--range-max q-col-6" }
const _hoisted_7 = { class: "q-small" }
const _hoisted_8 = ["data-field", "id", "name", "placeholder", "min"]
const _hoisted_9 = {
  key: 0,
  class: "q-input-group-text q-unit"
}

import {ref, inject, onMounted, computed, onUpdated, watch} from 'vue';
import {useFiltersStore} from "@/store/SerpPage/FiltersStore";
import {storeToRefs} from "pinia";
import {SmartSearchTranslationsInterface} from "@/core/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'InputRangeItem',
  props: ['filterData', 'field'],
  emits: ['closeDropdown', 'minInputChange', 'maxInputChange'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit;
const filtersStore = useFiltersStore()
const {getActiveFilters} = storeToRefs(filtersStore)

const minValue = ref(null)
const maxValue = ref(null)
const minError = ref(false)
const minErrorText = ref('')
const maxError = ref(false)
const maxErrorText = ref('')
const inputChanging = ref<'min' | 'max' | null>(null)


const minInputValue = ref<number | null>(props.filterData.min.toFixed(2));
const maxInputValue = ref<number | null>(props.filterData.max.toFixed(2));
const unit = ref(props.filterData.unit)

const handleMinInputChange = (event: Event) => {
  if (Number(event.target.value) < Number(minInputValue.value)) {
    minError.value = true
    minErrorText.value = `Minimalna wartość to: ${minInputValue.value}`
    return;
  }
  if (Number(event.target.value) > Number(maxInputValue.value)) {
    minError.value = true
    minErrorText.value = `Maksymalna wartość to: ${maxInputValue.value}`
    return
  }
  clearMinErrors()
  filtersStore.updateRangeValue(event, props.field, props.filterData, event.target.value, maxValue.value);
  inputChanging.value = 'min'
  emit('closeDropdown');
}


const handleMaxInputChange = (event: Event) => {
  if (Number(event.target.value) <= Number(minInputValue.value)) {
    maxError.value = true
    maxErrorText.value = `Minimalna wartość to: ${minInputValue.value}`
    return
  }
  clearMaxErrors()
  filtersStore.updateRangeValue(event, props.field, props.filterData, minValue.value, event.target.value);
  inputChanging.value = 'max'
  emit('closeDropdown');
}
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SmartSearchTranslations = inject<SmartSearchTranslationsInterface>('SmartSearchTranslations')!
const clearMinErrors = () => {
  minError.value = false
  minErrorText.value = ''
}

const clearMaxErrors = () => {
  maxError.value = false
  maxErrorText.value = ''
}
const clearErrors = (source = 'unkwown') => {
  clearMinErrors()
  clearMaxErrors()

}
onMounted(() => {
  setTimeout(() => {
    clearErrors('onMounted')
    if (getActiveFilters.value[props.field]) {
      minValue.value = getActiveFilters.value[props.field].min
      maxValue.value = getActiveFilters.value[props.field].max
    }
  }, 500)


})
onUpdated(()=>{
  const {min, max} = props.filterData
  minInputValue.value = min.toFixed(2)
  maxInputValue.value = max.toFixed(2)
})

watch(getActiveFilters, () => {
  clearErrors('onWatch')

  if (getActiveFilters.value[props.field]) {
    if (inputChanging.value === 'min') {
      minValue.value = getActiveFilters.value[props.field].min
    }
    if (inputChanging.value === 'max') {
      maxValue.value = getActiveFilters.value[props.field].max
    }
  } else {
    minValue.value = null
    maxValue.value = null
  }
}, {immediate: false});



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("small", _hoisted_3, _toDisplayString(_unref(SmartSearchTranslations).filters.from), 1),
      _createElementVNode("div", {
        class: _normalizeClass(["q-input-group-sm q-mb-3 q-d-flex q-position-relative", {'q-with-error': !!minError.value}])
      }, [
        _withDirectives(_createElementVNode("input", {
          class: _normalizeClass(["serp__filter--range-min-input q-form-control q-p-1 q-p-1 q-text-end", {'q-with-unit': !!unit.value }]),
          "data-field": __props.field,
          id: __props.field + '_min',
          name: __props.field + '_min',
          placeholder: minInputValue.value,
          min: minInputValue.value,
          type: "number",
          autocomplete: "off",
          onChange: _cache[0] || (_cache[0] = ($event: any) => (handleMinInputChange($event))),
          onEnter: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (handleMaxInputChange($event)), ["prevent"])),
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((minValue).value = $event))
        }, null, 42, _hoisted_4), [
          [_vModelText, minValue.value]
        ]),
        _withDirectives(_createElementVNode("span", { class: "error q-position-absolute" }, _toDisplayString(minErrorText.value), 513), [
          [_vShow, minError.value]
        ]),
        (unit.value)
          ? (_openBlock(), _createElementBlock("small", _hoisted_5, _toDisplayString(unit.value), 1))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("small", _hoisted_7, _toDisplayString(_unref(SmartSearchTranslations).filters.to), 1),
      _createElementVNode("div", {
        class: _normalizeClass(["q-input-group-sm q-mb-3 q-d-flex q-position-relative", {'q-with-error': !!maxError.value}])
      }, [
        _withDirectives(_createElementVNode("input", {
          class: _normalizeClass(["serp__filter--range-max-input q-form-control q-p-1 q-text-end", {'q-with-unit': !!unit.value}]),
          "data-field": __props.field,
          id: __props.field + '_max',
          name: __props.field + '_max',
          placeholder: maxInputValue.value,
          min: minInputValue.value,
          type: "number",
          autocomplete: "off",
          onChange: _cache[3] || (_cache[3] = ($event: any) => (handleMaxInputChange($event))),
          onEnter: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (handleMaxInputChange($event)), ["prevent"])),
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((maxValue).value = $event))
        }, null, 42, _hoisted_8), [
          [_vModelText, maxValue.value]
        ]),
        _withDirectives(_createElementVNode("span", { class: "error q-position-absolute" }, _toDisplayString(maxErrorText.value), 513), [
          [_vShow, maxError.value]
        ]),
        (unit.value)
          ? (_openBlock(), _createElementBlock("small", _hoisted_9, _toDisplayString(unit.value), 1))
          : _createCommentVNode("", true)
      ], 2)
    ])
  ]))
}
}

})